import React, { useRef, useState, useCallback } from "react";
import domtoimage from "dom-to-image-more";
import { useDropzone } from "react-dropzone";
import { Input } from "../../components/common/Input";
import "./styles.css";

export const ImageGenerator: React.FC = () => {
    const exportRef = useRef<HTMLDivElement>(null);
    const [exportedImage, setExportedImage] = useState<string | null>(null);

    const [complexName, setComplexName] = useState("");
    const [square, setSquare]         = useState("");
    const [floor, setFloor]           = useState("");
    const [price, setPrice]           = useState("");
    const [deposit, setDeposit]       = useState("");
    const [installment, setInstallment] = useState("");
    const [background, setBackground]   = useState<string | null>(null);

    const onDrop = useCallback((files: File[]) => {
        const file = files[0];
        const img  = new Image();
        img.src    = URL.createObjectURL(file);
        img.onload = () => {
            const reader = new FileReader();
            reader.onload = () => setBackground(reader.result as string);
            reader.readAsDataURL(file);
        };
    }, []);

    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept: { "image/*": [] },
    });

    const exportAsImage = async () => {
        const orig = exportRef.current;
        if (!orig) return;

        // 1) клонируем вашу карточку
        const clone = orig.cloneNode(true) as HTMLDivElement;
        Object.assign(clone.style, {
            width:       "1080px",
            height:      "1920px",
            maxWidth:    "none",
            aspectRatio: "auto",
            position:    "absolute",
            top:         "-9999px",
            left:        "-9999px",
            transform:   "none",
        });

        // 2) убираем flex и задаём реальный размер блока с фото
        const photo   = clone.querySelector<HTMLElement>(".ig-photo")!;
        const content = clone.querySelector<HTMLElement>(".ig-content")!;
        // задаём фиксированные размеры
        photo.style.flex       = "none";
        photo.style.width      = "1080px";
        photo.style.height     = "1520px";
        photo.style.minHeight  = "0";

        // контент — остальное
        content.style.flex     = "none";
        content.style.width    = "1080px";
        content.style.height   = "400px";

        document.body.appendChild(clone);

        // 3) ждём, пока img в clone подгрузится
        const imgs = Array.from(clone.querySelectorAll("img")) as HTMLImageElement[];
        await Promise.all(imgs.map(img =>
            new Promise<void>(res => {
                if (img.complete && img.naturalWidth > 0) return res();
                img.onload  = () => res();
                img.onerror = () => res();
            })
        ));

        // 4) рендерим JPEG точно 1080×1920
        domtoimage.toJpeg(clone, { quality: 0.95, width: 1080, height: 1920 })
            .then(dataUrl => setExportedImage(dataUrl))
            .catch(console.error)
            .finally(() => document.body.removeChild(clone));
    };


    const downloadImage = () => {
        if (!exportedImage) return;
        const link = document.createElement("a");
        link.href    = exportedImage;
        link.download= "story.jpeg";
        link.click();
    };

    return (
        <div className="form-wrapper">
            {/* Форма */}
            <div className="form-grid">
                <Input label="Название ЖК"      value={complexName}  onChange={setComplexName} />
                <Input label="Квадратура (м²)" value={square}       onChange={setSquare} />
                <Input label="Этаж"             value={floor}         onChange={setFloor} />
                <Input label="Полная стоимость" value={price}         onChange={setPrice} />
                <Input label="Взнос"            value={deposit}       onChange={setDeposit} />
                <Input label="Рассрочка"        value={installment}   onChange={setInstallment} />
            </div>

            {/* Загрузка фона */}
            <div {...getRootProps()} className="upload-box">
                <input {...getInputProps()} />
                <p>
                    {background
                        ? "Изображение загружено"
                        : "Перетащи или нажми, чтобы загрузить фон (JPG/PNG)"}
                </p>
            </div>

            {/* Превью-контейнер */}
            <div className="ig-preview">
                <div className="ig-card-wrapper" ref={exportRef}>
                    <div className="ig-photo">
                        {background && <img src={background} alt="Фон" />}
                        <div className="ig-title-overlay">{complexName || "Title"}</div>
                        <div className="ig-features">
                            <div className="ig-badge">{square || "65"} м²</div>
                            <div className="ig-badge">{floor || "12"} этаж</div>
                        </div>
                    </div>
                    <div className="ig-content">
                        <div className="ig-pricing">
                            <div className="ig-price">{price || "7800000"} ₽</div>
                            <div className="ig-deposit">
                                {deposit || "3000000"} ₽ <span className="ig-label">взнос</span>
                            </div>
                        </div>
                        <div className="ig-installment">
                            <div className="ig-label">Рассрочка</div>
                            <div className="ig-value">{installment || "Information"}</div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Экспорт */}
            <div className="button-group">
                <button onClick={exportAsImage} className="button-primary">
                    Экспорт в JPEG
                </button>
            </div>

            {/* Мобильный preview и загрузка */}
            {exportedImage && (
                <div className="mobile-preview">
                    <h3>Результат экспорта</h3>
                    <img src={exportedImage} alt="Exported" />
                    <button onClick={downloadImage} className="button-primary">
                        Скачать картинку
                    </button>
                </div>
            )}
        </div>
    );
};
